import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="min-h-screen w-full bg-[#FDF8F3] relative overflow-hidden" data-id="element-96">
      {/* Decorative blob */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#F3EDF7] rounded-full blur-3xl opacity-60 -translate-y-1/2 translate-x-1/3" data-id="element-97" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#B794C0] rounded-full blur-3xl opacity-20 translate-y-1/2 -translate-x-1/3" data-id="element-98" />

      <div className="max-w-6xl mx-auto px-6 py-16 md:py-24 relative z-10" data-id="element-99">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-100">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-2 md:order-1" data-id="element-101">
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2D2D] leading-tight mb-6" data-id="element-102">
              Emprender con hijos sin perder la cabeza
            </h1>

            <p className="text-xl md:text-2xl text-[#4A4A4A] mb-4 leading-relaxed" data-id="element-103">
              Cómo recuperar 3 horas de trabajo real al día{' '}
              <span className="italic" data-id="element-104">
                (incluso si tus hijos están en casa).
              </span>
            </p>

            <p className="text-lg text-[#4A4A4A] mb-8 leading-relaxed" data-id="element-105">
              El sistema de{' '}
              <strong className="text-[#B794C0]" data-id="element-106">
                Bloques de Alta Densidad (BAD)
              </strong>{' '}
              para madres multifacéticas que están cansadas de "avanzar a paso
              de tortuga" y quieren ver resultados en sus negocios sin
              sacrificar su presencia.
            </p>

            <motion.a href="#precio" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-[#E07A5F] text-white font-semibold text-lg px-8 py-4 rounded-full shadow-lg shadow-[#E07A5F]/30 transition-colors hover:bg-[#C96A52]" data-id="element-107">
              ¡Quiero mi copia al 50% de descuento!
            </motion.a>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-1 md:order-2 flex justify-center" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/qBqEGdbnAs4cXTQHunHqpJ/Mockup_1.png" alt="Ebook Emprender con Hijos en tablet" className="w-full max-w-md md:max-w-lg drop-shadow-2xl" data-id="element-109" />
          </motion.div>
        </div>
      </div>
    </section>;
}